<div id="cover-spin" [class.spin-visible]="loading"></div>
<div class="maincontainer spinner">
    <div class="search">
    <div class="status-filter">

    <kion-drop-down
            *ngIf="statusFilterValues$ | async"
            [title]="'filter.by.status' | translate"
            [options]="statusFilterValues$ | async"
            [showDropDownOnClick]="true"
            [showSelectedOption]="true"
            selectedOptionPosition="behind"
            (selected)="statusFilterChanged($event)"
    ></kion-drop-down>
    </div>
    <div class="search-box">
        <kion-search-box
                [resetValue]="resetValue"
                (searchTriggered)="search($event)"
                (searchBoxResetValue)="searchBoxResetValue()"
                (searchBoxCleared)="searchBoxCleared()"
        ></kion-search-box>
    </div>
    </div>
    <div class="userlistcontainer">
        <div class="gridcontainer">
            <div class="listheading">{{ 'admin.invite.headline.username' | translate }}</div>
            <div class="listheading">{{ 'admin.invite.headline.status' | translate }}</div>
            <div class="listheading">{{ 'admin.invite.headline.invitationid' | translate }}</div>
            <div class="listheading">{{ 'admin.invite.headline.actions' | translate }}</div>
        </div>
        <div class="gridcontainer" *ngFor="let employee of employees$ | async">
            <div class="username">{{ employee.firstName }} {{ employee.lastName }}</div>
            <div class="userid">{{ employee.userId }}</div>
            <div class="status">
                <kion-status-label [class]="employee.invitationStatus"
                                   [text]="'admin.invite.status.' + employee.invitationStatus?.toLowerCase() | translate">
                </kion-status-label>
            </div>
            <div class="statusid">{{ employee.invitationId }}</div>
            <div class="actions">
                <ng-container *ngIf="employee.invitationStatus !== 'ACCEPTED'">
                    <kion-button (clicked)="resendInvite(employee)" mode="small"
                                 title="{{ 'admin.invite.button.resend' | translate }}"></kion-button>
                    <kion-button (clicked)="deleteInvite(employee)" mode="small"
                                 title="{{ 'admin.invite.button.delete' | translate }}"></kion-button>
                </ng-container>
                <ng-container *ngIf="employee.invitationStatus === 'ACCEPTED'">
                    <kion-button (clicked)="openDialog(employee.userId)" mode="small"
                                 title="{{ 'admin.invite.button.edit' | translate }}"></kion-button>
                </ng-container>
            </div>
        </div>
    </div>
</div>
<div class="pagination" *ngIf="(employees$ | async) && (employees$ | async).length > 0">
    <kion-pagination
            *ngIf="pagination$ | async as pagination"
            [totalPages]="pagination.totalPages"
            [currentPage]="pagination.page"
            [defaultPerPageSelected]="pagination.perPage"
            (perPageChanged)="perPageChanged($event)"
            (pageChanged)="pageChanged($event)"
    ></kion-pagination>
</div>
